import { useCallback } from 'react';
import { auth } from '@landr/root-app/auth';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import { attemptedActionStore } from 'helpers/attemptedActionStore';
import { noop } from 'utils/noop';
import { AnyAuthenticatedUserAction, AuthenticatedActions } from 'types';

export type PrivateActionConfig = {
    handleAuthenticated?: () => void;
    handleGuest?: () => void;
    actionDescription: AnyAuthenticatedUserAction;
};

export function usePrivateAction(): (
    actionConfig: PrivateActionConfig,
) => void {
    const { isAuthenticated } = useAuthentication();

    const doPrivateAction = useCallback(
        ({
            handleAuthenticated = noop,
            handleGuest = noop,
            actionDescription,
        }: PrivateActionConfig) => {
            if (isAuthenticated) {
                handleAuthenticated();
            } else {
                handleGuest();
                attemptedActionStore.set(actionDescription);

                const skipProfileSurvey = [
                    AuthenticatedActions.openTrialUpsellModal,
                    AuthenticatedActions.downloadItem,
                ].includes(actionDescription.type as AuthenticatedActions);

                auth.login({ mfeName: 'samples', skipProfileSurvey }, true);
            }
        },
        [isAuthenticated],
    );

    return doPrivateAction;
}
